import React from 'react';
import { FormComponentProps } from '@ant-design/compatible/es/form';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Switch } from 'antd';

interface ICreateItineraryFeatureFormProps extends FormComponentProps {
  onSubmit: (values: ICreateItineraryFeatureFormValues) => any;
  feature?: Feature;
}
interface ICreateItineraryFeatureFormState {}

export interface Feature extends ICreateItineraryFeatureFormValues {
  id: string;
}

export interface ICreateItineraryFeatureFormValues {
  description: string;
  required: boolean;
}

class CreateItineraryFeatureForm extends React.Component<
  ICreateItineraryFeatureFormProps,
  ICreateItineraryFeatureFormState
> {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(
      (err, values: ICreateItineraryFeatureFormValues) => {
        if (!err) {
          this.props.onSubmit(values);
        }
      },
    );
  };

  render(): React.ReactNode {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form
        id="create-itinerary-feature-form"
        layout={'vertical'}
        onSubmit={this.handleSubmit}
      >
        <Form.Item label={'Descripción'} required={true}>
          {getFieldDecorator('description', {
            initialValue: this.props.feature?.description,
            rules: [
              {
                required: true,
                message: 'Por favor, introduce una descripción',
              },
            ],
          })(<Input.TextArea autoSize={{ minRows: 5, maxRows: 10 }} />)}
        </Form.Item>
        <Form.Item label={'Requerido'} required={true}>
          {getFieldDecorator('required', {
            valuePropName: 'checked',
            initialValue: this.props.feature?.required || true,
            rules: [
              {
                required: true,
              },
            ],
          })(<Switch />)}
        </Form.Item>
      </Form>
    );
  }
}
const MyCreateItineraryFeatureForm =
  Form.create<ICreateItineraryFeatureFormProps>()(CreateItineraryFeatureForm);

export default MyCreateItineraryFeatureForm;
